var mathUtilities = {
  getMean(data) {
    const n = data.length;
    return data.reduce((a, b) => a + b) / n;
  },

  getStandardDeviation(data) {
    const n = data.length;
    const mean = this.getMean(data);
    return Math.sqrt(
      data.map((x) => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n
    );
  },

  getMedian(arr = []) {
    const sorted = arr.slice().sort((a, b) => {
      return a - b;
    });
    if (sorted.length % 2 === 0) {
      const first = sorted[sorted.length / 2 - 1];
      const second = sorted[sorted.length / 2];
      return (first + second) / 2;
    } else {
      const mid = Math.floor(sorted.length / 2);
      return sorted[mid];
    }
  },

  getFWHM(data) {
    return 2.355 * this.getStandardDeviation(data);
  },
};

export default mathUtilities;
